<template>
    <div class="">

        <div class="py-8 container mx-auto text-center">

            <div class="">

                <div class="">

                    <div v-if="initial">
                        <p class="p-2">Was this site helpful for you?</p>

                        <p class="p-2">
                            <button v-on:click="submitYes()" class="btn btn-default">Yes</button>
                            <button v-on:click="submitNo()" class="btn btn-default">No</button>
                        </p>
                    </div>

                    <div v-if="yes">
                        <p style="font-weight:bold;">
                            Is there anything we can do to improve?
                        </p>

                        <label>
                            <textarea class="form-control" rows="5" name="message" v-model="message"></textarea>
                        </label>

                        <p>
                            <button class="btn btn-primary" v-on:click="submitUpdate()">Submit</button>
                        </p>
                    </div>

                    <div v-if="no">
                        <p>We are very sorry!
                            <br/>What can we do to improve this site?
                        </p>


                        <label>
                            <textarea class="form-control" rows="5" name="message" v-model="message"></textarea>
                        </label>

                        <p>
                            <button class="btn btn-primary" v-on:click="submitUpdate()">Submit</button>
                        </p>
                    </div>

                    <div v-if="thanks">
                        <p>Thanks for your feedback!</p>
                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>

    export default {

        props: ['token'],

        data: function () {
            return {
                id: false,
                status: 'initial',
                secret: false,
                message: '',
            };
        },

        computed: {
            initial: function () {
                return this.status === 'initial';
            },
            yes: function () {
                return this.status === 'yes';
            },
            no: function () {
                return this.status === 'no';
            },
            thanks: function () {
                return this.status === 'thanks';
            },
        },

        methods: {
            submitNo: function () {

                window.http
                    .post('/feedback', {
                        _token: this.token,
                        helpful: false,
                        url: window.location.href,
                    })
                    .then((response) => {
                        this.secret = response.data.secret;
                        this.id = response.data.id;
                    });
                this.status = 'no';
            },
            submitYes: function () {
                window.http
                    .post('/feedback', {
                        _token: this.token,
                        helpful: true,
                        url: window.location.href,
                    })
                    .then((response) => {
                        // just relax! ;-)
                    });
                this.status = 'yes';
            },
            submitUpdate: function () {
                window.http
                    .post('/feedback/' + this.id, {
                        _token: this.token,
                        _method: 'PUT',
                        secret: this.secret,
                        message: this.message
                    })
                    .then((response) => {
                        // just relax!
                    });
                this.status = 'thanks';
            }
        },

    }

</script>
